
import React, { useState, useEffect } from "react";
import { ArrowLeft, Eye, EyeOff } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

const AddUser = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // 👇 Must match AdminDashboard (editData)
  const editData = location.state?.editData || null;

  // 🔹 Form state
  const [userFirstname, setFirstName] = useState("");
  const [userLastname, setLastName] = useState("");
  const [address, setCity] = useState("");
  const [userPhoneno, setPhoneNumber] = useState("");
  const [userEmail, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [roleType, setRole] = useState("CLIENT");

  // ⭐ Prefill when editing
  useEffect(() => {
    if (editData) {
      setFirstName(editData.userFirstname || "");
      setLastName(editData.userLastname || "");
      setCity(editData.address || "");
      setPhoneNumber(editData.userPhoneno || "");
      setEmail(editData.userEmail || "");
      setRole(editData.roleType || "CLIENT");
    }
  }, [editData]);

  // Add or Update user
  const handleSubmit = async (e) => {
    e.preventDefault();



    // First name letters only
if (!/^[A-Za-z\s]+$/.test(userFirstname)) {
  toast.error("First name should contain letters only");
  return;
}

// Last name letters only
if (!/^[A-Za-z\s]+$/.test(userLastname)) {
  toast.error("Last name should contain letters only");
  return;
}

// Phone number must be exactly 10 digits
if (!/^\d{10}$/.test(userPhoneno)) {
  toast.error("Phone number must be exactly 10 digits");
  return;
}

// Email format
if (!/^[\w.-]+@[\w.-]+\.\w+$/.test(userEmail)) {
  toast.error("Enter a valid email address");
  return;
}
    

    const formData = {
      userFirstname,
      userLastname,
      address,
      userPhoneno,
      userEmail,
      roleType,
    };

    // Password only when creating a new user
    if (!editData) {
      formData.password = password;
    }

    const token = localStorage.getItem("token");
    const authHeaders = {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    };

    try {
      let response;

      if (editData) {
        response = await axios.put(
          `https://api.livestockify.com/api/urjabio/users/${editData.userUuid}`,
          formData,
          { headers: authHeaders },
        );

        toast.success("User updated successfully!");
      } else {
        response = await axios.post(
          "https://api.livestockify.com/api/urjabio/users",
          formData,
          { headers: authHeaders },
        );

        toast.success("User created successfully!");
      }

      navigate(-1);
    } catch (error) {
      console.error("Error:", error);
        if (error.response?.data?.message?.toLowerCase().includes("email")) {
    toast.error("Email already exists");
  } else {
    toast.error("Operation failed!");
  }
    }
  };

  return (
    <div className="min-h-screen py-8 px-4 sm:px-8 lg:px-16 bg-white ">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center text-black font-semibold mb-6 "
      >
        <ArrowLeft className="mr-2 h-5 w-5" />
        Back to dashboard
      </button>

      <form
        onSubmit={handleSubmit}
        className="  rounded-2xl p-6 sm:p-10 max-w-3xl mx-auto w-full"
      >
        <h2 className="text-lg sm:text-xl font-semibold text-[#34C759] mb-8 text-start">
          {editData ? "Update User" : "Create New User"}
        </h2>

        {/* ---- UI (unchanged) ---- */}
        <div className="space-y-5 sm:space-y-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6">
            <label className="sm:w-1/3 text-sm font-semibold text-gray-700">
              First Name
            </label>
            <input
              type="text"
              value={userFirstname}
              onChange={(e) => setFirstName(e.target.value)}
              placeholder="Enter First Name"
              className="w-full sm:w-2/3 border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6">
            <label className="sm:w-1/3 text-sm font-semibold text-gray-700">
              Last Name
            </label>
            <input
              type="text"
              value={userLastname}
              onChange={(e) => setLastName(e.target.value)}
              placeholder="Enter Last Name"
              className="w-full sm:w-2/3 border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6">
            <label className="sm:w-1/3 text-sm font-semibold text-gray-700">
              Address
            </label>
            <input
              type="text"
              value={address}
              onChange={(e) => setCity(e.target.value)}
              placeholder="Enter address"
              className="w-full sm:w-2/3 border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6">
            <label className="sm:w-1/3 text-sm font-semibold text-gray-700 pr-10">
              Phone Number
            </label>
            <input
              type="Number"
              value={userPhoneno}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="Phone Number"
              className="w-full sm:w-2/3 border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6">
            <label className="sm:w-1/3 text-sm font-semibold text-gray-700">
              Email ID
            </label>
            <input
              type="email"
              value={userEmail}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter Email ID"
              className="w-full sm:w-2/3 border border-gray-300 rounded-lg p-2 focus:ring-2 focus:ring-green-500 outline-none"
            />
          </div>

          {!editData && (
            <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6">
              <label className="sm:w-1/3 text-sm font-semibold text-gray-700">
                Password
              </label>
              <div className="relative w-full sm:w-2/3">
                <input
                  type={showPassword ? "text" : "password"}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter password"
                  required
                  className="w-full border border-gray-300 rounded-lg p-2 pr-10 focus:ring-2 focus:ring-green-500 outline-none"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword((prev) => !prev)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700"
                  aria-label={showPassword ? "Hide password" : "Show password"}
                >
                  {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
                </button>
              </div>
            </div>
          )}

          <div className="flex flex-col sm:flex-row sm:items-center sm:gap-6">
            <label className="sm:w-1/3 text-sm font-semibold text-gray-700">
              RoleType
            </label>

            <div className="flex gap-6 sm:w-2/3">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="roleType"
                  value="ADMIN"
                  checked={roleType === "ADMIN"}
                  onChange={() => setRole("ADMIN")}
                />
                <span className="text-gray-700">Admin</span>
              </label>

              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="roleType"
                  value="CLIENT"
                  checked={roleType === "CLIENT"}
                  onChange={() => setRole("CLIENT")}
                />
                <span className="text-gray-700">Client</span>
              </label>
            </div>
          </div>
        </div>

        {/* Button */}
        <div className="flex justify-center mt-10">
          <button
            type="submit"
            className="bg-[#34C759] hover:bg-green-700 text-white font-semibold py-2 
               px-8 md:px-20 lg:px-40 rounded-lg transition"
          >
            {editData ? "Update" : "Create"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddUser;
